import Api from "./globalApi";

const SYSTEM = "SYSTEM";
const IS_ERROR_WHILE_READING_DATA_OCCURED = "IS_ERROR_WHILE_READING_DATA_OCCURED";
const ERROR_MESSAGE = "ERROR_MESSAGE";
const SHOW_NATIONAL_DATA = "SHOW_NATIONAL_DATA";

const dataModule = {
    namespaced: true,
    state: () => ({
        system: null,
        isErrorWhileReadingDataOccurred: null,
        errorMessage: "",
        showNationalData: false,
    }),
    mutations: {
        [SYSTEM](state, system) {
            state.system = system;
        },
        [IS_ERROR_WHILE_READING_DATA_OCCURED](state, isErrorWhileReadingDataOccurred) {
            state.isErrorWhileReadingDataOccurred = isErrorWhileReadingDataOccurred;
        },
        [ERROR_MESSAGE](state, errorMessage) {
            state.errorMessage = errorMessage;
        },
        [SHOW_NATIONAL_DATA](state, shouldBeDisplayed) {
            state.showNationalData = shouldBeDisplayed;
        },
    },
    actions: {
        readSystemData({ commit }, aoqnUserId) {
            return Api.GetSystemData(aoqnUserId)
                .then((result) => { commit("SYSTEM", result.data); });
        },
        // toggling national data visibility
        setNationalData({ commit }, shouldBeDisplayed) {
            return commit(SHOW_NATIONAL_DATA, shouldBeDisplayed);
        },
        setIsErrorWhileReadingDataOccurred({ commit }, error) {
            commit(IS_ERROR_WHILE_READING_DATA_OCCURED, error.occurred);
            commit(ERROR_MESSAGE, error.message);
        }
    },
};

export default dataModule;
